<template>
    <modal @close="closeModal">
        <h1 class="modal__title">{{ type }} {{ trans('action.add') }}</h1>
        <form @submit.prevent="addSrvRecordValue">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <label class="field__label">{{ trans('page.dns.table.priority') }}</label>
                    <input
                        v-model="form.priority"
                        :placeholder="trans('page.dns.table.priority')"
                        class="field__input | u-margin-bottom | dusk-dns-modal-priority"
                        ref="priority"
                        autofocus
                    />
                </div>
                <!--
             -->
                <div class="layout__item u-1/3-desk">
                    <label class="field__label">{{ trans('page.dns.table.weight') }}</label>
                    <input
                        v-model="form.weight"
                        :placeholder="trans('page.dns.table.weight')"
                        class="field__input | u-margin-bottom | dusk-dns-modal-weight"
                        ref="weight"
                    />
                </div>
                <!--
             -->
                <div class="layout__item u-1/3-desk">
                    <label class="field__label">{{ trans('page.dns.table.port') }}</label>
                    <input
                        v-model="form.port"
                        :placeholder="trans('page.dns.table.port')"
                        class="field__input | u-margin-bottom | dusk-dns-modal-port"
                        ref="port"
                    />
                </div>
            </div>

            <label class="field__label">{{ trans('page.dns.table.target') }}</label>
            <input
                v-model="form.content"
                :placeholder="trans('page.dns.table.target')"
                class="field__input | u-margin-bottom | dusk-dns-modal-content"
                ref="content"
            />

            <div class="modal__nav">
                <button @click="closeModal" class="btn btn--ghost-gray btn-ghost--dns | u-margin-right">
                    {{ trans('action.cancel') }}
                </button>
                <button class="btn btn--blue-record btn-ghost--dns" type="submit">
                    {{ trans('action.save') }}
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import { Way2Form } from 'relapp-way2forms';
import { Modal } from 'relapp-modal';

export default {
    components: {
        Modal
    },
    props: {
        type: String,
        name: String,
        priority: Number,
        weight: Number,
        port: Number,
        content: String
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                type: this.type,
                name: this.name,
                priority: this.priority,
                weight: this.weight,
                port: this.port,
                content: this.content
            })
        };
    },
    /**
     * Component is mounted, set the focus on the value input.
     */
    mounted() {
        this.$refs.priority.focus();
    },
    methods: {
        /**
         * Send the records to the parent component, and close the modal.
         */
        addSrvRecordValue() {
            let tmp = {};

            tmp.name = this.form.name;
            tmp.priority = parseInt(this.form.priority);
            tmp.weight = parseInt(this.form.weight);
            tmp.port = parseInt(this.form.port);
            tmp.content = this.form.content;
            this.$emit('value', tmp);
            this.$emit('close');
        },

        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>
